import {
    Box,
    Heading, Text
} from 'grommet';

import ResponsiveGrid from "../ResponsiveGrid";

const columns = {
    small: ["100%"],
    medium: ["45%", "auto"],
    large: ["45%", "auto"],
};

const rows = {
    small: ["auto"],
    medium: ["auto"],
    large: ["auto"],
    xlarge: ["xxsmall"]
};

const createBar = (score,max) => {
    const maxScore = max;
    const perc = score / maxScore * 100;
    const rem = 100 - perc;
    let color;
    if(perc > 80) {color = "#719A57"} else
    if(perc > 60) {color = "#B2DF97"} else
    if(perc > 40) {color = "#F9E195"} else
    if(perc > 20) {color = "#DFB07A"} else {
        color = "#E88986"
    }
    return `linear-gradient(to right, ${color} ${perc}%, white ${perc}%, white ${rem}%)`
}

const style = {
    backgroundColor: '#FFFFFF',
    borderBottomStyle: 'solid',
    borderBottomColor: '#B1B1B1',
    borderBottomWidth: '1.5px',
    color: '#232C3B',
    textDecoration: 'none',
}

const anchorStyle = {
    color: '#232C3B',
    textDecoration: 'none',
}

function GraphTableRow({score,cid, name, max}) {
    const url = `https://energydemocracyyall.org/scorecards/coop/?cid=${cid}`
    return (
        <ResponsiveGrid
            width="100%"
            height="45px"
            overrideColumns={columns}
            overrideRows={rows}
        >
            <Box
                flex={false}
                justify="center"
                style={style}
                pad="small"
            >
                <Text as="a" style={anchorStyle} href={url}>{name}</Text>
            </Box>
            <Box
                flex={false}
                justify="center"
                style={{
                    ...style,
                    background: createBar(score, max)
                }}
                pad="small"
            >
                <Text>{score}</Text>
            </Box>
        </ResponsiveGrid>
    );
}

export default GraphTableRow;